import { Tooltip } from "@crayon/design-system-react";
import { WarningCirceIcon } from "images/MuiIcons";

export enum TooltipMessage {
  PsaNotAuthorized = "PSA is not authorized for the current partner",
  ContractIsInUse = "Partner already has billing mapping with this contract or agreement",
}

interface WarningIconWithTooltipProps {
  message: TooltipMessage;
}

const WarningIconWithTooltip = ({ message }: WarningIconWithTooltipProps) => (
  <Tooltip title={message}>
    <WarningCirceIcon color="warning" />
  </Tooltip>
);

export default WarningIconWithTooltip;
